import React, { FC } from 'react'
import { FormBlockContainer } from './styled'

interface FormBlockProps {
	className?: string
	centered?: boolean
	sticky?: boolean
}
export const FormBlockComponent: FC<FormBlockProps> = ({
	children,
	className,
	centered,
	sticky,
}) => {
	return children ? (
		<FormBlockContainer className={className} centered={centered} sticky={sticky}>
			{children}
		</FormBlockContainer>
	) : null
}
